<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text" title="Usuarios" class="px-5 py-3">
      <v-data-table :headers="headers" :items="users" item-key="id" class="elevation-1" :search="search"
        :loading="isUsersTableLoading">
        <template v-slot:top>
          <v-text-field v-model="search" outlined label="Buscar en usuarios..." class="mx-4" />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon v-if="$store.getters.hasPermission('Usuarios', 'Editar')" small class="mr-2"
            @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon v-if="$store.getters.hasPermission('Usuarios', 'Editar')" small class="mr-2 ml-2"
            @click="changePassword(item)">mdi-form-textbox-password</v-icon>
          <v-icon v-if="$store.getters.hasPermission('Usuarios', 'Eliminar')" small
            @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </base-material-card>

    <v-fab-transition>
      <v-btn v-if="$store.getters.hasPermission('Usuarios', 'Crear')" class="mb-10 fab-button" fab color="blue darken-2"
        bottom right absolute fixed @click="openCreateUserDialog">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-row justify="center">
      <formulario-usuarios :isEditMode="isEditMode" :isUserDialogVisible="isUserDialogVisible"
        :IsUserFormValid="IsUserFormValid" :userData="userData" :profiles="profiles"
        :isUserButtonLoading="isUserButtonLoading" @update:isUserDialogVisible="isUserDialogVisible = $event"
        @submit-user="isEditMode ? editUserConfirm() : createUser()">
      </formulario-usuarios>
    </v-row>

    <v-dialog v-model="showEliminarItem" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Eliminar usuario</v-card-title>
        <v-card-text>¿Estas seguro que deseas eliminarlo?</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="danger" text @click="showEliminarItem = false">No</v-btn>
          <v-btn color="primary" text :loading="isLoadingBtnDelete" @click="confirmDelete">Sí</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showChangePasswordItem" width="500">
      <v-card>
        <v-card-title class="text-h5">Cambiar Contraseña</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="newPassword" label="Nueva contraseña" required outlined />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="danger" text @click="showChangePasswordItem = false">Cancelar</v-btn>
          <v-btn color="primary" text :loading="isLoadingChangePassword" @click="confirmChangePassword">Sí</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar 
      v-model="isUserSnackBarVisible" 
      :color="snackbarColor" 
      :timeout="1700" 
      top
      @input="val => { if (!val) resetSnackbar() }"
      >
      {{ snackbarMessage }}
      <template 
        v-slot:action="{ attrs }">
        <v-btn 
          text 
          v-bind="attrs" 
          @click="isUserSnackBarVisible = false"
          >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>


  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import FormularioUsuarios from './components/FormularioUsuarios.vue'

export default {
  components: {
    FormularioUsuarios
  },
  data() {
    return {
      newPassword: '',
      newPasswordData: '',
      search: '',
      deleteItemObj: '',
      snackbarMessage:"",
      snackbarColor:"",
      showEliminarItem: false,
      showChangePasswordItem: false,
      IsUserFormValid:true,
      isUserSnackBarVisible:false,
      isUserDialogVisible: false,
      isUserButtonLoading: false,
      isLoadingBtnDelete: false,
      isUsersTableLoading: true,
      isLoadingChangePassword: false,
      isEditMode: false,
      users: [],
      profiles: [],
      userData: {
        id: '',
        displayName: '',
        email: '',
        password: '',
        perfil: '',
      }
    }
  },
  computed: {
    headers() {
      return [
        { text: 'Nombre', align: 'start', sortable: false, value: 'displayName' },
        { text: 'Email', value: 'email' },
        { text: 'Perfil', value: 'perfil' },
        { text: 'Acción', value: 'actions' },
      ]
    }
  },
  mounted() {
    this.getUsersAll()
    this.getProfiles()
  },
  methods: {
    getUsersAll() {
      this.users = []
      this.isUsersTableLoading = true
      firebase.firestore().collection('users').get().then(snapshot => {
        snapshot.forEach(user => {
          this.users.push({ id: user.id, ...user.data() })
        })
        this.isUsersTableLoading = false
      }).catch(() => {
        this.isUsersTableLoading = false
      })
    },
    getProfiles() {
      this.profiles = []
      firebase.firestore().collection('perfiles').get().then(snapshot => {
        snapshot.forEach(profile => {
          this.profiles.push({ id: profile.id, ...profile.data() })
        })
      })
    },
    openCreateUserDialog() {
      this.userData = { id: '', displayName: '', email: '', perfil: '', password: '' }
      this.isEditMode = false
      this.isUserDialogVisible = true
    },
    editItem(user) {
      this.userData = {
        id: user.id || '',
        displayName: user.displayName || '',
        email: user.email || '',
        perfil: user.perfil || '',
        password: ''
      }
      this.isEditMode = true
      this.isUserDialogVisible = true
    },
    async createUser() {
        this.isUserButtonLoading = true
        try {
          console.log('createUser - userData:', this.userData)
          if (!this.userData || !this.userData.displayName || !this.userData.email || !this.userData.password) {
            console.error('createUser - Datos de usuario incompletos:', this.userData)
            throw new Error('Datos de usuario incompletos')
          }
          const createNewUser = firebase.functions().httpsCallable('createNewUser')
          const result = await createNewUser({
            user: {
              displayName: this.userData.displayName,
              email: this.userData.email,
              password: this.userData.password
            }
          })
          console.log('createUser - resultado función:', result)
          const uid = result.data.data.uid
          await firebase.firestore().collection('users').doc(uid).set({
            uid,
            displayName: this.userData.displayName,
            email: this.userData.email,
            perfil: this.userData.perfil
          })
          this.getUsersAll()
          this.resetDialog()
          this.snackbarMessage="Usuario creado exitosamente"
          this.snackbarColor="green darken-2"
        } catch (error) {
          console.error('createUser - error:', error)
          this.snackbarMessage="Hubo un error al crear el usuario"
          this.snackbarColor="error"
        } finally {
          this.isUserButtonLoading = false
          this.isUserSnackBarVisible=true
        }
    },
    async editUserConfirm() {
      this.isUserButtonLoading = true
      try {
        const updateUser = firebase.functions().httpsCallable('updateUser')
        await updateUser({ user: this.userData })
        await firebase.firestore().collection('users').doc(this.userData.id).update({
          displayName: this.userData.displayName,
          email: this.userData.email,
          perfil: this.userData.perfil
        })
        this.getUsersAll()
        this.resetDialog()
        this.snackbarMessage="Usuario editado exitosamente"
        this.snackbarColor="blue darken-2"
      } catch (error) {
        console.error("ERROR EDITANDO USUARIO", error)
        this.snackbarMessage="Hubo un error al editar al usuario : "+ error.message
        this.snackbarColor="red"
      } finally {
        this.isUserButtonLoading = false
        this.isUserSnackBarVisible=true
      }
    },
    resetDialog() {
      this.userData = { id: '', displayName: '', email: '', password: '', perfil: '' }
      this.isUserDialogVisible = false
      this.isEditMode = false
    },
    deleteItem(item) {
      this.deleteItemObj = item
      this.showEliminarItem = true
    },
    confirmDelete() {
      const objId = this.deleteItemObj.id
      this.isLoadingBtnDelete = true
      const deleteUser = firebase.functions().httpsCallable('deleteUser')
      deleteUser({ user: { id: objId } }).then(() => {
        firebase.firestore().collection('users').doc(objId).delete().then(() => {
          this.isLoadingBtnDelete = false
          this.showEliminarItem = false
          this.getUsersAll()
          this.snackbarMessage="Usuario eliminado exitosamente"
          this.snackbarColor="red darken-2"
          this.isUserSnackBarVisible=true
        })
      })
    },
    changePassword(item) {
      this.newPasswordData = item
      this.showChangePasswordItem = true
    },
    confirmChangePassword() {
      this.newPasswordData.password = this.newPassword
      this.isLoadingChangePassword = true
      const updateUser = firebase.functions().httpsCallable('updatePassword')
      updateUser({ user: this.newPasswordData }).then(() => {
        this.isLoadingChangePassword = false
        this.showChangePasswordItem = false
        this.getUsersAll()
      })
    },
    resetSnackbar() {
    this.snackbarMessage = ''
    this.snackbarColor = ''
    this.isUserSnackBarVisible = false
  }
  }
}
</script>

<style scoped>
.fab-button {
  margin-right: -.5rem !important;
}
</style>
